import React, { useEffect, useState } from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { BUTTON_VARIANTS } from '../../../components/common-components/button/Constants';
import Button from '../../../components/common-components/button/Button';
import ModalComponent from '../../../components/common-components/modal/ModalComponent';
import { useDispatch, useSelector } from 'react-redux';
import Icons from '../../../components/icons/Icons';
import Input from '../../../components/common-components/input/Input';
import General from '../../../libs/utility/General';
import { getValidationSchema } from '../../../libs/formsUtils';
import { VALIDATION_REGEX } from '../../../libs/constant';
import { FORM_FIELDS_NAMES } from './Constants';
import { abhaIntAadhaarValidation, checkExistingAadhaar} from '../../../pages/Patients/AddPatient/AddPatientSaga';
import ValidateOTPModal from './ValidateOTPModal';
import { componentKey, setOpenValidateOtpModal } from '../../../pages/Patients/AddPatient/AddPatientSlice';
import ConsentFormABHA from "./consentFormABHA" 
import CaptchaField from '../../../components/common-components/captcha/CaptchaField';
import aadhaarImg from "../../../assets/images/aadhaar.png"

const fields = [
	{
		fieldName: FORM_FIELDS_NAMES.AADHAR_NUMBER,
		isRequired: true,
		regexPattern: VALIDATION_REGEX.AADHAR_REGEX,
	},
];

const validationSchema = getValidationSchema(fields)
.shape({
  captchaInput: Yup.string()
    .required('CAPTCHA is required')
    .test('match-captcha', 'Incorrect CAPTCHA', function (value) {
      return value === this.parent.captchaCode;
    }),
});

const ImportFromAadhaar = ({ open, close }) => {
	const { openValidateOtpModal } = useSelector((state) => state[componentKey]);
	const [openConsentForm, setOpenConsentForm] = useState(false);
	const [isMasked, setIsMasked] = useState(true)
	const [key,setkey]=useState(0)

	const dispatch = useDispatch();

	return (
		<>
			<Formik
			// key={key}
				initialValues={{
					[FORM_FIELDS_NAMES.AADHAR_NUMBER]: '',
					captchaInput: '',
					captchaCode: '',
					}}
				validationSchema={validationSchema}
				enableReinitialize
				validateOnChange={false}
				onSubmit={async (values) => {
					const aadhar = values[FORM_FIELDS_NAMES.AADHAR_NUMBER].replace(/-/g, '');
					//dispatch(checkExistingAadhaar(Number(aadhar)));
					dispatch(abhaIntAadhaarValidation(String(aadhar)))
					setOpenConsentForm(false);
					close();
				}}
			>
				{({
					submitForm,
					isSubmitting,
					handleReset,
					values,
					handleSubmit,
					setFieldValue,
					setFieldError,
					handleBlur,
					...props
				}) => {
					return (
						<>
							<Form>
								<div>
									<ModalComponent
										open={open}
										title={'Create ABHA account'}
										footerButton={
											<Button
												//type="submit"
												type="button"
												variant={BUTTON_VARIANTS.CONTAINED}
												customBtnClass="text-met-primary"
			
												onClickCb={(e)=> {
													e.preventDefault();
													if(values[FORM_FIELDS_NAMES.AADHAR_NUMBER]?.replace(/-/g, '')
															.length === 12 && values.captchaInput === values.captchaCode
													){

													setOpenConsentForm(true)
													}
												}}		
												icon={<Icons iconName="closeIcon" />}									
											>
												Verify
											</Button>
										}
										icon={<Icons iconName="closeIcon" />}
										close={close}
										customClasses="w-[800px]"
									>
										<div className="p-2">
											<div className='w-full flex flex-col justify-center items-center'>
												<img className='w-[100px] p-3 border-2 rounded-xl border-blue-600' src={aadhaarImg}/>
												<p>Aadhaar</p>
												</div>
											<div className="flex column-gap-10px items-center pt-6">
												<div className="flex-1">
													<div className='flex gap-4 relative'>
														<Input
															label="Aadhaar Number"
															type={isMasked? "password" : "text"}
															placeholder="Please enter Aadhaar Number"
															isRequired={true}
															name={FORM_FIELDS_NAMES.AADHAR_NUMBER}
															value={values[FORM_FIELDS_NAMES.AADHAR_NUMBER]}
															onChangeCb={(e) => {
																const formattedValue = General.formateAadhar(
																	e.target.value
																);
																setFieldValue(
																	FORM_FIELDS_NAMES.AADHAR_NUMBER,
																	formattedValue
																);
																setFieldError(FORM_FIELDS_NAMES.AADHAR_NUMBER, undefined)
															}}
															onBlurCb={handleBlur}
														/>
														<div className='absolute right-2 top-8 '>
														<button onClick={(e)=>{
															e.preventDefault();
															setIsMasked(!isMasked)
															
														}}>{isMasked ? <Icons iconName={"eyeIcon"}/> : <Icons iconName={"eyeSlashIcon"}/>}</button>
															
														</div>
													</div>
													<div>
													<CaptchaField name="captchaInput" onChangeCb={(e)=>{
														setFieldError("captchaInput", undefined);
														setFieldValue("captchaInput", e.target.value);
														}} />
													</div>
												</div>
											</div>
										</div>
									</ModalComponent>
								</div>
							</Form>
							{openConsentForm && 
								<ConsentFormABHA close={() => setOpenConsentForm(false)} onSubmit={handleSubmit} />
							}
						</>
					);
				}}
			</Formik>
		</>
	);
};

export default ImportFromAadhaar;
